const theme = {
  bgDark: '#252b35',
  primary: '#03a9f4',
  secondary: '#f4027a',
};

export default theme;
